const PREFIX = "logika_filsuf_v1_";
export const KEYS = [
  "session", "profile", "settings", "books", "reading_progress", "reading_sessions",
  "notes", "recommendations", "argument_analyses", "cart", "orders", "subscription",
];

const currentYear = new Date().getFullYear();

export const DEFAULTS = {
  session: null,
  profile: { displayName: "Pembaca Logika", email: "logika@filsuf.com" },
  settings: {
    annualGoalBooks: 12,
    monthlyGoalMinutes: 600,
    dailyMinutes: 30,
    preferredLevel: "Pemula",
    preferredIntensity: "Sedang",
    notifReminder: true,
    notifWeekly: false,
    theme: "gelap",
    goalYear: currentYear,
  },
  books: [],
  reading_progress: [],
  reading_sessions: [],
  notes: [],
  recommendations: [],
  argument_analyses: [],
  cart: [],
  orders: [],
  subscription: null,
};

const clone = (v) => JSON.parse(JSON.stringify(v));

export class StorageError extends Error {}

export const uid = (prefix = "id") =>
  `${prefix}_${Date.now().toString(36)}${Math.random().toString(36).slice(2, 8)}`;
export const nowIso = () => new Date().toISOString();

function emit(key) {
  window.dispatchEvent(new CustomEvent("lf-storage", { detail: { key } }));
}

export function read(key) {
  const fallback = clone(DEFAULTS[key]);
  let raw;
  try {
    raw = localStorage.getItem(PREFIX + key);
  } catch {
    return fallback;
  }
  if (raw === null) return fallback;
  try {
    const parsed = JSON.parse(raw);
    const expectArray = Array.isArray(DEFAULTS[key]);
    if (expectArray && !Array.isArray(parsed)) throw new Error("bad shape");
    if (key === "settings" || key === "profile") return { ...fallback, ...parsed };
    return parsed;
  } catch {
    try {
      localStorage.setItem(`${PREFIX}corrupt_${key}_${Date.now()}`, raw);
      localStorage.setItem(PREFIX + key, JSON.stringify(fallback));
    } catch { /* ignore */ }
    return fallback;
  }
}

export function write(key, value) {
  try {
    localStorage.setItem(PREFIX + key, JSON.stringify(value));
  } catch (e) {
    const quota = e && (e.name === "QuotaExceededError" || e.code === 22);
    throw new StorageError(
      quota
        ? "Penyimpanan peramban penuh. Hapus beberapa data lama (mis. riwayat analisis) lalu coba lagi."
        : "Gagal menyimpan data di peramban Anda."
    );
  }
  emit(key);
}

export const list = (key) => read(key);
export const get = (key, id) => read(key).find((x) => x.id === id) || null;

export function add(key, item) {
  const rec = { id: uid(key.slice(0, 3)), createdAt: nowIso(), updatedAt: nowIso(), ...item };
  write(key, [rec, ...read(key)]);
  return rec;
}

export function update(key, id, patch) {
  let out = null;
  const next = read(key).map((x) => {
    if (x.id !== id) return x;
    out = { ...x, ...patch, updatedAt: nowIso() };
    return out;
  });
  write(key, next);
  return out;
}

export function remove(key, id) {
  write(key, read(key).filter((x) => x.id !== id));
}

export function initStorage() {
  try {
    KEYS.forEach((k) => {
      if (localStorage.getItem(PREFIX + k) === null) {
        localStorage.setItem(PREFIX + k, JSON.stringify(DEFAULTS[k]));
      }
    });
  } catch { /* storage unavailable */ }
}

export function resetDemoData() {
  const session = read("session");
  KEYS.forEach((k) => {
    try { localStorage.removeItem(PREFIX + k); } catch { /* ignore */ }
  });
  Object.keys(localStorage)
    .filter((k) => k.startsWith(PREFIX))
    .forEach((k) => localStorage.removeItem(k));
  initStorage();
  write("session", session);
  KEYS.forEach(emit);
}
